import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["paymentAmount", "clientReference"]

  connect(){
    this.initValidation()
  }

  initValidation(){
    const paymentAmountId = this.paymentAmountTarget.id
    $(this.element).validate( {
      ignore: [],
      errorPlacement: function(error, element) {
        switch (element.attr("id")) {
          case paymentAmountId:
            element.parent().parent().append(error);
            break;
          default:
            element.parent().append(error);
            break;
        }
      }
    })

    $(this.clientReferenceTarget).rules('add', {
      maxlength: this.clientReferenceValidationRules.maxlength
    })

    $(this.paymentAmountTarget).rules('add', {
      required: true,
    })
  }

  get pageAlertElement(){
    return document.getElementById('page-alert')
  }

  get clientReferenceValidationRules(){
    if(!this.clientReferenceTarget.dataset.validationRules) throw 'Provide client refrence validation'
    
    return JSON.parse(this.clientReferenceTarget.dataset.validationRules)
  }
}